var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88257 9.99967C1.88257 9.55765 2.05663 9.13372 2.36645 8.82116C2.67628 8.5086 3.0965 8.33301 3.53466 8.33301C3.97282 8.33301 4.39303 8.5086 4.70286 8.82116C5.01269 9.13372 5.18675 9.55765 5.18675 9.99967C5.18675 10.4417 5.01269 10.8656 4.70286 11.1782C4.39303 11.4907 3.97282 11.6663 3.53466 11.6663C3.0965 11.6663 2.67628 11.4907 2.36645 11.1782C2.05663 10.8656 1.88257 10.4417 1.88257 9.99967Z",
    fill: "#9EA3AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49097 9.99967C8.49097 9.55765 8.66503 9.13372 8.97485 8.82116C9.28468 8.5086 9.70489 8.33301 10.1431 8.33301C10.5812 8.33301 11.0014 8.5086 11.3113 8.82116C11.6211 9.13372 11.7951 9.55765 11.7951 9.99967C11.7951 10.4417 11.6211 10.8656 11.3113 11.1782C11.0014 11.4907 10.5812 11.6663 10.1431 11.6663C9.70489 11.6663 9.28468 11.4907 8.97485 11.1782C8.66503 10.8656 8.49097 10.4417 8.49097 9.99967Z",
    fill: "#9EA3AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0992 9.99967C15.0992 9.55765 15.2733 9.13372 15.5831 8.82116C15.893 8.5086 16.3132 8.33301 16.7513 8.33301C17.1895 8.33301 17.6097 8.5086 17.9195 8.82116C18.2294 9.13372 18.4034 9.55765 18.4034 9.99967C18.4034 10.4417 18.2294 10.8656 17.9195 11.1782C17.6097 11.4907 17.1895 11.6663 16.7513 11.6663C16.3132 11.6663 15.893 11.4907 15.5831 11.1782C15.2733 10.8656 15.0992 10.4417 15.0992 9.99967Z",
    fill: "#9EA3AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.06d13d1af926172e86d6a20770e32c1e.svg";
export { ForwardRef as ReactComponent };